<template>
  <GestionTicketsPostventa modo-ticketera="reparacion0km" />
</template>

<script>
import GestionTicketsPostventa from './GestionTicketsPostventa.vue'

export default {
  name: 'GestionTicketsReparacionVehiculos0km',
  components: {
    GestionTicketsPostventa,
  },
}
</script>
